import { cn } from '../../lib/cn';
import type { AIAlphaValidationRow } from '../../enterpriseacceptance/framework';

type Props = { results?: AIAlphaValidationRow[] };

export function AlphaAIValidationPanel({ results = [] }: Props) {
  return (
    <div className="space-y-2">
      {results.map((r) => (
        <div key={r.check} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{r.check}</p>
            <p className="text-xs text-slate-500">{r.detail}</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-semibold">{r.score}%</p>
            <span className={cn(
              'text-xs font-medium',
              r.status === 'passed' ? 'text-success-600' : 'text-error-600',
            )}>
              {r.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
